import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, Fab, Tooltip } from '@material-ui/core';
import { Remove as MinusIcon } from '@material-ui/icons';

class FormMinusButton extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        removeDetail: PropTypes.func.isRequired,
    };

    static defaultProps = {};

    render() {
        const { removeDetail, classes } = this.props;

        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip title={Translator.translate('general.add')} placement="top">
                    <Fab
                        aria-label={Translator.translate('general.add')}
                        className={`${classes.btnEdit} ${classes.fabSave}`}
                        size="small"
                        onClick={removeDetail}
                    >
                        <MinusIcon className={classes.icon} />
                    </Fab>
                </Tooltip>
            </div>
        );
    }
}

const styles = theme => ({
    fabSave: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        width: 25,
        minHeight: 25,
    },
    btnEdit: {
        marginRight: 8,
        height: 25,
        width: 25,
    },
    icon: {
        fontSize: '0.5rem',
    },
});

export default withStyles(styles, { withTheme: true })(FormMinusButton);



// WEBPACK FOOTER //
// ./data/components/FormMinusButton.js